module.exports = __webpack_public_path__ + "img/huace6.c0cb6d6b.jpg";